(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationTopicDetailController', CommunicationTopicDetailController);

    CommunicationTopicDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CommunicationTopic'];

    function CommunicationTopicDetailController($scope, $rootScope, $stateParams, entity, CommunicationTopic) {
        var vm = this;
        vm.communicationTopic = entity;
        vm.load = function (id) {
            CommunicationTopic.get({id: id}, function(result) {
                vm.communicationTopic = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:communicationTopicUpdate', function(event, result) {
            vm.communicationTopic = result;
        });
        
        
        $scope.$on('$destroy', unsubscribe);

    }
})();
